<template>
  <b-row class="mt-3 mb-3">
    <b-col cols="1"></b-col>
    <b-col>
      <b-row>
        <b-col>({{item.code}}) {{item.name}}</b-col>
        <b-col class="text-right">
          <b-link :href="'#/editTopic/'+item.id">ویرایش</b-link>
        </b-col>
      </b-row>
      <div v-for="item in getList" v-bind:key="item.id">
        <topicItem v-bind:list="list" v-bind:item="item"></topicItem>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import TopicItem from "./topicItem";
export default {
  name: "TopicItem",
  props: ["item", "list"],
  components: {
    TopicItem
  },
  computed: {
    getList() {
      var id = this.item.id;
      return this.list.filter(function(element) {
        return element.parent_id == id;
      });
    }
  }
};
</script>